// Qué tab de Mantenimiento le toca pedir sus datos.
//
// Vivía dentro del efecto como `if (tools.length === 0) return`, que confunde
// dos cosas distintas: que todavía no se sabe qué herramientas hay, y que no hay
// ninguna. Con el almacén vacío nunca se disparaba la carga, así que Alertas e
// Historial se quedaban con el spinner girando para siempre.

export type TabDeMantenimiento = 'mantenimiento' | 'alertas' | 'historial'

export interface EstadoDeCargaDeTabs {
  /** Ya terminó la petición base, con o sin herramientas. */
  baseLista: boolean
  historialCargado: boolean
  historialCargando: boolean
  alertasCargadas: boolean
  alertasCargando: boolean
}

/**
 * El tab que hay que pedir en este render, o null si no hay nada pendiente.
 * Cada tab se pide una sola vez, la primera que se abre.
 */
export const tabPorCargar = (
  tab: TabDeMantenimiento,
  estado: EstadoDeCargaDeTabs,
): 'alertas' | 'historial' | null => {
  // Sin la base no se puede pedir: el historial y las alertas se arman sobre la
  // lista de herramientas y el mapa de usuarios.
  if (!estado.baseLista) return null

  if (tab === 'historial' && !estado.historialCargado && !estado.historialCargando) {
    return 'historial'
  }

  if (tab === 'alertas' && !estado.alertasCargadas && !estado.alertasCargando) {
    return 'alertas'
  }

  return null
}
